<div class="personal-visit-list">
<sc-no-data-container [hasData]="this.dataSource.data.length > 0" class="table-container">

  <table class="mat-table-selection" mat-table [dataSource]="dataSource" matSort matSortActive="{{sortColumn}}"
    [matSortDirection]="sortDirection">
    <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->
    <ng-container matColumnDef="noRecord">
      <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="hint">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'hint'|
        translate:['tmc-visit.entity.visit.hint', translationService.language]}}</th>
      <td mat-cell *matCellDef="let visit">
        <span class="{{c}}" *ngFor="let c of getHintClasses(visit)"></span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'name'|
        translate:['tmc-visit.entity.visit.name', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.name}} </td>
    </ng-container>

    <ng-container matColumnDef="firstname">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'firstname'|
        translate:['tmc-visit.entity.visit.firstname', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.firstname}} </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'company'|
        translate:['tmc-visit.entity.visit.company', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.company}} </td>
    </ng-container>

    <ng-container matColumnDef="visitedPerson">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitedPerson'|
        translate:['tmc-visit.entity.visit.visitedperson', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.visitedPersonString}} </td>
    </ng-container>

    <ng-container matColumnDef="visitedPersonName">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitedPersonName'|
        translate:['tmc-visit.entity.visit.visitedperson.name', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.visitedPersonName}} </td>
    </ng-container>

    <ng-container matColumnDef="visitedPersonDepartment">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitedPersonDepartment'|
        translate:['tmc-visit.entity.visit.visitedperson.department', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.visitedPersonDepartment}} </td>
    </ng-container>

    <ng-container matColumnDef="reason">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'reason'|
        translate:['tmc-visit.entity.visit.reason', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.reason}} </td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'notes'|
        translate:['tmc-visit.entity.visit.notes', translationService.language]}}</th>
      <td mat-cell class="multiple-lines text-selection" *matCellDef="let visit"> {{visit.notes}} </td>
    </ng-container>

    <ng-container matColumnDef="numberPlate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'numberPlate'|
        translate:['tmc-visit.entity.visit.numberplate', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.numberPlate}} </td>
    </ng-container>

    <ng-container matColumnDef="start">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'start'|
        translate:['tmc-visit.entity.visit.start', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.start}} </td>
    </ng-container>

    <ng-container matColumnDef="registrationCode">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'registration code'|
        translate:['tmc-visit.entity.visit.registrationCode', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.registrationCode}} </td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitor role'|
        translate:['tmc-visit.entity.visit.role', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.role}} </td>
    </ng-container>

    <ng-container matColumnDef="expectedArrival">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'expectedArrival'|
        translate:['tmc-visit.entity.visit.expectedArrival', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.expectedArrival}}</td>
    </ng-container>

    <ng-container matColumnDef="lastTerminalRegistrationDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'lastTerminalRegistrationDate'|
        translate:['tmc-visit.entity.visit.lastTerminalRegistrationDate', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.lastTerminalRegistrationDate}}</td>
    </ng-container>

    <ng-container matColumnDef="lastClientRegistrationDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'lastClientRegistrationDate'|
        translate:['tmc-visit.entity.visit.lastClientRegistrationDate', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.lastClientRegistrationDate}}</td>
    </ng-container>

    <ng-container matColumnDef="visitStatus">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitStatus'|
        translate:['tmc-visit.entity.visit.visitStatus', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit">
          {{visit.visitStatus | translate:['tmc-visit.common.enum.visitStatus.' + visit.personalVisitStatus, translationService.language]}}
      </td>
    </ng-container>

    <ng-container matColumnDef="internal">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'internal'|
        translate:['tmc-visit.entity.visit.internal', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit">
          {{visit.internal === true ? this.translationService.translate('common.enum.boolean.yes') : this.translationService.translate('common.enum.boolean.no')}}
      </td>
    </ng-container>

    <ng-container matColumnDef="instructionsStatus">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'instructionsStatus'|
        translate:['tmc-visit.entity.visit.instructionsStatus', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit">
        <ng-container *ngIf="visit.instructionsStatus">
          {{visit.instructionsStatus | translate:['tmc-visit.common.enum.instructionsStatus.' + visit.instructionsStatus, translationService.language]}}
        </ng-container>
        <ng-container *ngIf="!visit.instructionsStatus">
          {{visit.instructionsStatus | translate:['tmc-visit.common.enum.instructionsStatus.NOT_DONE', translationService.language]}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="supplementaryEquipments">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'supplementaryEquipments'|
        translate:['tmc-visit.entity.visit.supplementaryEquipments', translationService.language]}}</th>
      <td mat-cell class="multiple-lines text-selection" *matCellDef="let visit"> {{visit.supplementaryEquipments}} </td>
    </ng-container>

    <ng-container matColumnDef="invitationSentDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'invitationSentDate'|
        translate:['tmc-visit.entity.visit.invitationSentDate', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.invitationSentDate}}</td>
    </ng-container>

    <ng-container matColumnDef="filler">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> &nbsp; </th>
      <td mat-cell *matCellDef="let visit"> &nbsp; </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

    <tr mat-row *matRowDef="let visit; columns: columnsToDisplay" [ngClass]="getRowStyles(visit)"
      (click)="toggleSelection(visit)"></tr>

  </table>

</sc-no-data-container>

<sc-content-spacer [vertical]="true" double></sc-content-spacer>
<div class="counts">
  angezeigt werden: {{dataSource.data.length}}/{{totalCount}}
</div>
</div>